// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap/dist/css/bootstrap.css'
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import VueResource from 'vue-resource'
import VeeValidate, {
  Validator
} from 'vee-validate'
import VueMask from 'v-mask'
import Auth from '@/auth2'
import Bus from '@/bus'

import VueResourceMock from 'vue-resource-mock'
import MockData from '../mockdatas/mockdata.js'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/pt-br'
import locale from 'element-ui/lib/locale'


import 'bootstrap/dist/js/bootstrap.js'
import ptBR from 'vee-validate/dist/locale/pt_BR'

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(VeeValidate)
Vue.use(VueMask)

if (process.env.MOCK_SERVER) {
  Vue.use(VueResourceMock, MockData, /* { silent: true/false } */ )
}

locale.use(lang)
Vue.use(ElementUI)
Validator.localize('pt_BR', ptBR)

export var bus = new Bus()
export var auth = new Auth(router)

router.beforeEach((to, from, next) => {
  if (!auth.initialized) {
    auth.saveForward(next, to)
  } else if (to.meta.auth && !auth.authenticated) {
    auth.saveForward(next, to)
    router.push({
      path: 'login'
    })
  } else {
    next()
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js